module.exports = __webpack_public_path__ + "img/rotate-counter-clockwise.a7cbc1c5.svg";